import VModal from "@/vuetify_custom/v-modal_v1";
import VTable from "@/vuetify_custom/v-table/v3";
import PageContain from "@/views/components/PageContain.vue";
import * as XLSX from "xlsx";
import { getCustomerSalaryAdjustApplyDownBatchAdjustApi } from "@/views/fin/salaryadministration/service.js";
export default {
  data() {
    return {
      show: false,
      loading: false,
      params: {
        team_id: null,
        file: null,
      },
      records: [],
      target_name: null,
    };
  },
  computed: {
    table_fields() {
      return [
        {
          text: "员工姓名",
        },
        {
          text: "身份证号",
        },
        {
          text: "调整前薪资",
          type: "money_field",
        },
        {
          text: "调整后薪资",
          type: "money_field",
        },
        {
          text: "调整金额",
          type: "money_field",
        },
        {
          text: "调整比例",
        },
        {
          text: "调薪生效日期",
        },
      ].map((item) => ({
        ...item,
        value: item.text,
      }));
    },
  },
  methods: {
    edit(target) {
      this.target_name = target.file_name;
      this.show = true;
      this.loading = true;
      getCustomerSalaryAdjustApplyDownBatchAdjustApi({ id: target.id })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=UTF-8",
          });
          const file = new window.File([blob], target.file_name, {
            type: "application/vnd.ms-excel;charset=UTF-8",
          });

          const workbook = XLSX.read(res.data, { type: "array" });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          let a = XLSX.utils.sheet_to_json(worksheet);
          if (Array.isArray(a) && a.length > 0) {
            a = a.map((item) => {
              return {
                ...item,
                ["调整比例"]: (item["调整比例"] * 100).toFixed(1) + "%",
              };
            });
            this.records = a;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  render() {
    return (
      <VModal
        v-model={this.show}
        title={this.target_name}
        width={500}
        loading={this.uploading}
        fullscreen
        cancelText=""
        successColor=""
        okText="关闭"
        okTextDis
        on={{
          ok: () => {
            this.show = false;
            this.records = [];
          },
        }}
      >
        <div>
          <PageContain reserved-height={152}>
            <VTable
              loading={this.loading}
              fixedHeader
              headers={this.table_fields}
              desserts={this.records}
            />
          </PageContain>
        </div>
      </VModal>
    );
  },
};
